import { render, staticRenderFns } from "./exhibition-form.vue?vue&type=template&id=523312ca&"
import script from "./exhibition-form.vue?vue&type=script&lang=js&"
export * from "./exhibition-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports